const routePaths = {
  Dashboard: '/',
  Customers: '/customers',
  CustomerDetails: '/customers/:id',
  CustomerCreate: '/customers/create',
  CustomerCreateComplete: '/customers/create/complete/:id',
  CustomerEdit: '/customers/:id/edit',
  CustomerChangeStatus: '/customers/:id/change-status',
  CustomerChangeFreezeStatus: '/customers/:id/change-freeze-status',
  CustomerCreatePortfolio: '/customers/:id/create-portfolio',
  CustomerLinkExternalIdentity: '/customers/:id/link-external-identity',
  CustomerChangeEmail: '/customers/:id/change-email',
  CustomerChangeTradingViewUsername: '/customers/:id/change-tradingview-username',
  CustomerResetPassword: '/customers/:id/reset-password',
  CustomerAddTradingStrategySubscription: '/customers/:id/trading-strategy-subscriptions/add',
  CustomerManageTradingStrategySubscription: '/customers/:id/trading-strategy-subscriptions/:strategyId/manage',
  CustomerGrantOffer: '/customers/:id/grant-offer',
  CustomerAddMembership: '/customers/:id/memberships/add',
  CustomerEndMembership: '/customers/:id/memberships/:membershipId/end',
  CustomerResumeMembership: '/customers/:id/memberships/:membershipId/resume',
  CustomerReviewMembership: '/customers/:id/memberships/:membershipId/review',
  CustomerAddAddOn: '/customers/:id/add-ons/add',
  CustomerEndAddOn: '/customers/:id/add-ons/:addOnId/end',
  CustomerResumeAddOn: '/customers/:id/add-ons/:addOnId/resume',
  CustomerInviteTradingViewScripts: '/customers/:id/tradingview-scripts/invite',
  CustomerRemoveTradingViewScripts: '/customers/:id/tradingview-scripts/remove',
  Symbols: '/symbols',
  SymbolDetails: '/symbols/:id',
  SymbolCreate: '/symbols/create',
  SymbolCreateComplete: '/symbols/create/complete/:id',
  SymbolEdit: '/symbols/:id/edit',
  Templates: '/templates',
  TemplateDetails: '/templates/:id',
  TemplateCreate: '/templates/create',
  TemplateEdit: '/templates/:id/edit',
  TemplateChangeStatus: '/templates/:id/change-status',
  TemplateAdjustAssociatedSymbols: '/templates/:id/adjust-associated-symbols',
  TradingStrategies: '/trading-strategies',
  TradingStrategyDetails: '/trading-strategies/:id',
  TradingStrategyCreate: '/trading-strategies/create',
  TradingStrategyEdit: '/trading-strategies/:id/edit',
  TradingStrategyEnableRealTimeUpdates: '/trading-strategies/:id/enable-real-time-updates',
  TradingStrategyTurnOffRealTimeUpdates: '/trading-strategies/:id/turn-off-real-time-updates',
  TradingStrategyChangeStatus: '/trading-strategies/:id/change-status',
  MembershipRequests: '/customer-memberships/requests',
  AccessToGrant: '/tradingview-script-invites/access-to-grant',
  AccessToRemove: '/tradingview-script-invites/access-to-remove',
  BrochureCatalogue: '/brochure-catalogue',
  BrochureCatalogueCreate: '/brochure-catalogue/new',
  BrochureCatalogueRevisionChangeStatus: '/brochure-catalogue/:id/change-status',
  BrochureCatalogueRevisionDetails: '/brochure-catalogue/:id',
  PortfolioBuilder: '/portfolio-builder',
  PortfolioBuilderNewRevision: '/portfolio-builder/new',
  PortfolioBuilderRevisionChangeStatus: '/portfolio-builder/:id/change-status',
  PortfolioBuilderRevisionDetails: '/portfolio-builder/:id',
  PortfolioTracker: '/portfolio-tracker',
  PortfolioTrackerResults: '/portfolio-tracker/results',
  PortfolioTrackerDifferences: '/portfolio-tracker/results/differences',
  PortfolioTrackerStrategy: '/portfolio-tracker/results/strategies/:key',
  Offers: '/offers',
  OfferCreate: '/offers/create',
  OfferDetails: '/offers/:id',
  OfferEdit: '/offers/:id/edit',
  OfferChangeStatus: '/offers/:id/change-status',
  OfferGrant: '/offers/:id/grant',
  OfferRevokeGrant: '/offers/:id/grants/:customerId/revoke',
  AddOns: '/add-ons',
  AddOnDetails: '/add-ons/:id',
  AddOnEdit: '/add-ons/:id/edit',
  AddOnChangeStatus: '/add-ons/:id/change-status',
  MembershipPlatforms: '/memberships',
  MembershipPlatformCreate: '/memberships/create',
  MembershipPlatformDetails: '/memberships/:id',
  MembershipPlatformEdit: '/memberships/:id/edit',
  MembershipTierCreate: '/memberships/:id/tiers/create',
  MembershipTierDetails: '/memberships/:id/tiers/:tierId',
  MembershipTierEdit: '/memberships/:id/tiers/:tierId/edit',
  MembershipTierChangeStatus: '/memberships/:id/tiers/:tierId/change-status',
  Baskets: '/baskets',
  BasketDetails: '/baskets/:id',
  BasketCreate: '/baskets/create',
  BasketCreateComplete: '/baskets/create/complete/:id',
  BasketEditTemplateAllocations: '/baskets/:id/edit-template-allocations',
  BasketChangeStatus: '/baskets/:id/change-status',
  BasketMigrateTemplate: '/baskets/:id/migrate-template',
  PortfolioDetails: '/portfolios/:id',
  PortfolioChangeStatus: '/portfolios/:id/change-status',
  PortfolioEdit: '/portfolios/:id/edit',
  PortfolioEditAllocations: '/portfolios/:id/edit-allocations',
  IncomingSignals: '/incoming-signals',
  IncomingSignalDetails: '/incoming-signals/:id',
  IncomingSignalWebhookUrls: '/incoming-signals/webhook-urls',
  IncomingSignalReplay: '/incoming-signals/:id/replay',
  IncomingSignalSend: '/incoming-signals/send',
  StrategyDataAlerts: '/strategy-data-alerts',
  StrategyDataAlertDetails: '/strategy-data-alerts/:id',
  StrategyDataAlertWebhookUrls: '/strategy-data-alerts/webhook-urls',
  InfoAlerts: '/info-alerts',
  InfoAlertDetails: '/info-alerts/:id',
  InfoAlertWebhookUrls: '/info-alerts/webhook-urls',
  UnknownAlerts: '/unknown-alerts',
  UnknownAlertDetails: '/unknown-alerts/:id',
  Webhooks: '/webhooks',
  WebhookDetails: '/webhooks/:id',
  SignalRequests: '/signal-requests',
  SignalRequestDetails: '/signal-requests/:id',
  ExitPositions: '/exit-positions',
  LateEntry: '/late-entry',
  EmailNotifications: '/email-notifications',
  TriggerEmailSync: '/email-notifications/trigger-sync',
  EmailNotificationDetails: '/email-notifications/:id',
  CustomerFeedback: '/customer-feedback',
  StrategyRequests: '/strategy-requests',
  CleanseStrategyRequest: '/strategy-requests/:id/cleanse',
  TriageCustomerFeedback: '/customer-feedback/:id/triage',
  OutstandingActionsDigestRuns: '/outstanding-actions/digest-runs',
  TriggerOutstandingActionsDigest: '/outstanding-actions/digest-runs/trigger',
  MarketCandleRuns: '/market-candles',
  FetchMarketCandles: '/market-candles/fetch',
  MarketCandleRunDetails: '/market-candles/:id',
  DevTools: '/dev-tools',
  AdminPermissions: '/admin/permissions',
  Processes: '/processes',
  FillStrategyHistory: '/processes/fill-strategy-history',
  RecalculateFromStoredData: '/processes/recalculate-from-stored-data',
  TurnOnRealTimeUpdates: '/processes/turn-on-real-time-updates',
  Unauthorized: '/unauthorized',
} as const

export default routePaths
